module.exports = {"id":"138806","name":"Maximiliano López","rating":"74","photo":"./data/images/photos/2/138806.png","club":{"name":"Udinese","logo":"./data/images/clubs/Udinese.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximilianoLopez0.json
// module id = 2951
// module chunks = 0